import { render, staticRenderFns } from "./Despacho.vue?vue&type=template&id=e86f44c8&"
import script from "./Despacho.vue?vue&type=script&lang=js&"
export * from "./Despacho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports